module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjOUI5QjlCIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj4KICAgICAgICA8cGF0aCBkPSJNNy4wNzEgNy4wNzFsMTQuMTQyIDE0LjE0Mk0yMS4yMTMgNy4wNzFMNy4wNzEgMjEuMjEzIi8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x-gray.svg
// module id = 934
// module chunks = 0